import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import {
  Col, Form, Row, Button, Spinner,
} from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import SweetAlert from 'react-bootstrap-sweetalert';
import useAuth from '../../hooks/useAuth';
import '../auth.css';
import UserCard from '../../components/userCard';
import useForm from '../../hooks/useForm';
import { logout, changePassword } from '../../services/MockAuthService';
import IdleTimer from '../../services/idleTimer';
import AlertTimeout from '../../components/alertTimeout';

function Reset() {
  const title = 'Reset Password';
  const { getSession } = useAuth();
  const user = getSession();
  // Form elements
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [catchError, setIsCatchError] = useState('');
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);

  const [isTimeout, setIsTimeout] = useState(false);
  const handleLogout = async () => {
    await logout();
    navigate('/');
    setIsTimeout(true);
  };
  useEffect(() => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const onSuccess = () => {
    navigate('/console/dashboard');
    setIsAlert(false);
  };

  const handleSetPassword = async (e, data) => {
    if (data.password.length < 6) {
      setIsCatchError('Password should be min 6 characters');
      setIsError(true);
      return;
    }
    if (data.password !== data.confirmPassword) {
      setIsCatchError('Password does not match');
      setIsError(true);
      return;
    }
    try {
      setIsLoading(true);
      await changePassword(user.MEMBER_ID, data.currentPassword, data.password);
      setIsAlert(true);
      setIsLoading(false);
    } catch (err) {
      setIsCatchError(err.message);
      setIsError(true);
      setIsLoading(false);
    }
  };

  const validators = {
    currentPassword: {
      required: {
        value: true,
        message: 'Password is required',
      },
    },
    confirmPassword: {
      required: {
        value: true,
        message: 'Password is required',
      },
    },
    password: {
      required: {
        value: true,
        message: 'password is required',
      },
    },
  };

  // Using a custom hook to show how we can build out our own hook.
  const {
    handleChange,
    handleSubmit,
    errors,
  } = useForm({
    onSubmit: handleSetPassword,
    validators,
  });

  const onConfirm = () => {
    setIsAlert(false);
    setIsError(false);
  };

  const onCancel = () => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
        setIsTimeout(true);
      },
    });
    setIsTimeout(false);
    return () => {
      timer.cleanUp();
    };
  };

  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/console/dashboard">Dashboard</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className="page-title">{title}</h1>
          <div className="row">
            <div className="col-lg-4 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-8 rounded">
              <div className="mb-4">
                <div className="card mb-4 mb-lg-0">
                  <h6 className="card-header d-flex justify-content-between align-items-center">
                    Reset Password
                  </h6>
                  <div className="card-body">
                    <Form onSubmit={handleSubmit} >
                      <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                        <Form.Label column sm="2">
                          Email
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control plaintext readOnly defaultValue={user.EMAIL} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                        <Form.Label column sm="2">
                          Current
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            type="password"
                            isInvalid={ errors.currentPassword }
                            onChange={handleChange('currentPassword')}
                          />
                        </Col>
                        <Form.Control.Feedback type="invalid">
                          Current Password is required
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                        <Form.Label column sm="2">
                          New
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            type="password"
                            isInvalid={ errors.password }
                            onChange={handleChange('password')}
                          />
                        </Col>
                        <Form.Control.Feedback type="invalid">
                          New Password is required
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                        <Form.Label column sm="2">
                          Confirm
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control
                            type="password"
                            isInvalid={ errors.confirmPassword }
                            onChange={handleChange('confirmPassword')}
                          />
                        </Col>
                        <Form.Control.Feedback type="invalid">
                          Confirm Password is required
                        </Form.Control.Feedback>
                      </Form.Group>
                      <div>{Object.keys(errors)
                        .map((key) => <div className="text-danger" key={key}>{errors[key]}</div>)}</div>
                      <div className="d-flex ">
                      <Button className="btn btn-green my-3"
                              disabled={isLoading}
                              onClick={handleSubmit}
                      >
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading}/>
                        <span className="px-2">Submit</span>
                      </Button>
                      <Button type="button"
                              className="btn btn-light m-3"
                              onClick={() => navigate('/console/dashboard')}
                      >
                        Back to Dashboard
                      </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {isAlert
        && <SweetAlert
          success
          title="Password Successfully Changed"
          onConfirm={onSuccess}
        >
        </SweetAlert>
        }
        {isError
        && <SweetAlert
          warning
          title={catchError}
          onConfirm={onConfirm}
          timeout={10000}
        >
        </SweetAlert>}
        {isTimeout
        && <AlertTimeout onConfirm={handleLogout} onCancel={onCancel}/>
        }
      </>
    );
  }
  navigate('/login');
}

export default Reset;
